import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
/* Constants */
import {
  ENTRYPOINT_ICONS_WITH_TEXT,
  CAPITAL_ONE_LOGO_SRC_NON_PARTNER,
  CAPITAL_ONE_ENTRY_POINT_CONTENT,
} from 'site-modules/shared/constants/financing/financing-constants';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
/* Components */
import { Link } from 'site-modules/shared/components/link/link';
import { IconWithText } from './icon-with-text';

export function CapitalOneEntryPointNonPartner({
  vinData = PropTypes.shape({}),
  isCapOne = false,
  isCapOneIneligible = false,
}) {
  return (
    <>
      <hr style={{ marginTop: '24px', marginBottom: '16px' }} />
      <div
        className="capital-one-container non-partner"
        style={{ textAlign: 'left' }}
        data-tracking-parent={`${get(vinData, 'type', '').toLowerCase()}-summary_financing-${
          isCapOne ? 'matched' : 'unmatched'
        }-vin${isCapOneIneligible ? '-ineligible' : ''}`}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
          }}
        >
          <img
            width={73}
            height={26}
            src={getStaticImageUrl(CAPITAL_ONE_LOGO_SRC_NON_PARTNER)}
            alt="Capital One"
            style={{ marginBottom: '4px' }}
          />
          <h2
            className="text-cool-gray-30"
            style={{
              fontWeight: 'bold',
              fontSize: '20px',
              marginBottom: '12px',
            }}
          >
            {CAPITAL_ONE_ENTRY_POINT_CONTENT.TITLE}
          </h2>
          <div
            style={{
              width: '100%',
              marginTop: '4px',
              marginBottom: '4px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {ENTRYPOINT_ICONS_WITH_TEXT.map((info, index) => (
              <IconWithText key={`entry-point-icon_${index + 1}`} info={info} isCapOneIneligible={isCapOneIneligible} />
            ))}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Link
              to={`/financing/${isCapOneIneligible ? 'prequalify-and-shop' : vinData.vin}/basics`}
              className="btn btn-sm btn-success"
              style={{
                marginTop: '12px',
                fontSize: '16px',
                fontWeight: 'medium',
                textTransform: 'none',
              }}
              data-tracking-id="financing_cta"
              data-tracking-value={CAPITAL_ONE_ENTRY_POINT_CONTENT.CTA_TEXT}
            >
              <span>{CAPITAL_ONE_ENTRY_POINT_CONTENT.CTA_TEXT}</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

CapitalOneEntryPointNonPartner.propTypes = {
  vinData: PropTypes.shape({}),
  isCapOne: PropTypes.bool,
  isCapOneIneligible: PropTypes.bool,
};
